import React from "react";
import LicensesDetailsTable from "./LicensesDetailsTable";
import { Button, Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage, useIntl } from "react-intl";
import { formatDate, dateGetMonth, dateGetYear, diffMonths, dateAddMonths } from "../../Utilities/dateUtils";
import { saveAs } from "file-saver";

const LicensesDetails = (props) => {
  const intl = useIntl();
  if (!props.showLicenseDetails) {
    return null;
  }
  let rows = [];
  let columns = [];
  let columnBands = [];
  let listColumns = [];
  let dataForYearExcel = "";
  let title;

  const listFileNamePrefixes = {
    Active: "AktivaLicenser",
    Expired: "UtgångnaLicenser",
    Expiring: "UtgåendeLicenser",
  };

  let schoolsWithSelectedLicense = (props.schools ?? []).filter(
    function (school) {
      return school.programLicenses.some(
        (license) => license.name === props.selectedLicenseDetail[1],
      );
    },
  );

  const color = (text, status) => {
    const colors = { expired: "text-danger", added: "text-success" };
    let color = colors[status];
    return <span className={color}>{text}</span>;
  };

  const autoRenewText = (license) =>
    intl.formatMessage({ id: license.autoRenew ? "Yes" : "No" });

  const getDataForLicenseDiff = () => {
    var now = new Date();
    title = intl.formatMessage(
      { id: "LicenseDiffTableTitle" },
      { year: String(now.getFullYear()) }
    );
    var yearStart = new Date(now.getFullYear(), 0, 1);

    let nbrMonthsThisYear = diffMonths(now, yearStart) + 1;

    var interim = new Date(yearStart);
    var monthsThisYear = [];
    for (let i = 0; i < nbrMonthsThisYear; i++) {
      monthsThisYear.push(formatDate(interim, "yyyy-MM-dd").substring(0, 7));
      interim = dateAddMonths(interim, 1);
    }

    monthsThisYear = monthsThisYear.reverse();

    let expiredLicenses = [];
    let schoolsWithExpiredLicense = schoolsWithSelectedLicense.filter(
      (school) => {
        return school.programLicenses.some(
          (license) =>
            license.hasExpired &&
            license.name === props.selectedLicenseDetail[1]
        );
      }
    );
    schoolsWithExpiredLicense.forEach((schoolWithExpired) => {
      let licenseExpired = schoolWithExpired.programLicenses.filter(
        (license) => {
          return license.name === props.selectedLicenseDetail[1];
        }
      );
      expiredLicenses.push(licenseExpired);
    });

    monthsThisYear.forEach((month) => {
      let addedLicenses = [];
      let expiredLicenseThisMonth = expiredLicenses.filter(
        (lic) =>
          dateGetMonth(lic[0].validTo) === dateGetMonth(month) &&
          dateGetYear(lic[0].validTo) === dateGetYear(month)
      );
      schoolsWithSelectedLicense.forEach((school) => {
        let schoolWithNewLicense = school.programLicenses.filter((lic) => {
          return (
            lic.name === props.selectedLicenseDetail[1] &&
            dateGetMonth(month) === dateGetMonth(lic.addedDate) &&
            dateGetYear(month) === dateGetYear(lic.addedDate)
          );
        });
        if (schoolWithNewLicense.length > 0)
          addedLicenses.push(schoolWithNewLicense);
      });
      let monthToAdd = {
        id: month,
        parentId: null,
        title: formatDate(month, "MMMM"),
        expiredLicences: color(expiredLicenseThisMonth.length, "expired"),
        newLicences: color(addedLicenses.length, "added"),
      };
      dataForYearExcel +=
        "<tr><td style=font-weight:bold;>" +
        formatDate(month, "MMMM") +
        "</td><td style=background-color:'#FFC7CE'>" +
        expiredLicenseThisMonth.length +
        "</td><td style=background-color:'#C6EFCE'>" +
        addedLicenses.length +
        "</td></tr>";
      let expiredMonth = {
        parentId: month,
        id: month + "expired",
        title: color(intl.formatMessage({ id: "ExpiredLicenses" }), "expired"),
        expiredLicences: color(expiredLicenseThisMonth.length, "expired"),
      };
      let addedMonth = {
        parentId: month,
        id: month + "added",
        title: color(intl.formatMessage({ id: "AddedLicenses" }), "added"),
        newLicences: color(addedLicenses.length, "added"),
      };
      expiredLicenseThisMonth.forEach((expired) => {
        let schoolWithExpiredLicense = schoolsWithSelectedLicense.filter(
          (school) => school.id === expired[0].customerId
        );

        let exp = {
          id: schoolWithExpiredLicense[0].fortKnoxCustomerNumber + month,
          name: color(schoolWithExpiredLicense[0].name, "expired"),
          customerNumber: color(
            schoolWithExpiredLicense[0].fortKnoxCustomerNumber,
            "expired"
          ),
          address: color(schoolWithExpiredLicense[0].adress.street, "expired"),
          postalNumber: color(
            schoolWithExpiredLicense[0].adress.zipCode,
            "expired"
          ),
          city: color(schoolWithExpiredLicense[0].adress.city, "expired"),
          parentId: month + "expired",
        };
        rows.push(exp);
        dataForYearExcel +=
          "<tr><td></td><td></td><td></td><td align='right' style=background-color:'#FFC7CE'>" +
          schoolWithExpiredLicense[0].fortKnoxCustomerNumber +
          "</td><td align='right' style=background-color:'#FFC7CE'>" +
          schoolWithExpiredLicense[0].name +
          "</td><td align='right' style=background-color:'#FFC7CE'>" +
          schoolWithExpiredLicense[0].adress.street +
          "</td><td align='right' style=background-color:'#FFC7CE'>" +
          schoolWithExpiredLicense[0].adress.zipCode +
          "</td><td align='right' style=background-color:'#FFC7CE'>" +
          schoolWithExpiredLicense[0].adress.city +
          "</td></tr>";
      });

      addedLicenses.forEach((added) => {
        let schoolWithNewLicense = schoolsWithSelectedLicense.filter(
          (school) => school.id === added[0].customerId
        );

        let add = {
          id: schoolWithNewLicense[0].fortKnoxCustomerNumber + month,
          name: color(schoolWithNewLicense[0].name, "added"),
          customerNumber: color(
            schoolWithNewLicense[0].fortKnoxCustomerNumber,
            "added"
          ),
          address: color(schoolWithNewLicense[0].adress.street, "added"),
          postalNumber: color(schoolWithNewLicense[0].adress.zipCode, "added"),
          city: color(schoolWithNewLicense[0].adress.city, "added"),
          parentId: month + "added",
        };
        rows.push(add);
        dataForYearExcel +=
          "<tr><td></td><td></td><td></td><td align='left' style=background-color:'#C6EFCE'>" +
          schoolWithNewLicense[0].fortKnoxCustomerNumber +
          "</td><td align='left' style=background-color:'#C6EFCE'>" +
          schoolWithNewLicense[0].name +
          "</td><td align='left' style=background-color:'#C6EFCE'>" +
          schoolWithNewLicense[0].adress.street +
          "</td><td align='left' style=background-color:'#C6EFCE'>" +
          schoolWithNewLicense[0].adress.zipCode +
          "</td><td align='left' style=background-color:'#C6EFCE'>" +
          schoolWithNewLicense[0].adress.city +
          "</td></tr>";
      });
      rows.push(addedMonth);
      rows.push(monthToAdd);
      rows.push(expiredMonth);
    });

    columns = [
      { name: "title", title: <FormattedMessage id="Month" /> },
      { name: "newLicences", title: <FormattedMessage id="AddedLicenses" /> },
      {
        name: "expiredLicences",
        title: <FormattedMessage id="ExpiredLicenses" />,
      },
      {
        name: "customerNumber",
        title: <FormattedMessage id="FortnoxNumber" />,
      },
      { name: "name", title: <FormattedMessage id="Name" /> },
      { name: "address", title: <FormattedMessage id="Address" /> },
      { name: "postalNumber", title: <FormattedMessage id="ZipCode" /> },
      { name: "city", title: <FormattedMessage id="City" /> },
    ];
    columnBands = [
      {
        title: "Antal",
        children: [
          { columnName: "newLicences" },
          { columnName: "expiredLicences" },
        ],
      },
      {
        title: "Skolor",
        children: [
          { columnName: "customerNumber" },
          { columnName: "name" },
          { columnName: "address" },
          { columnName: "postalNumber" },
          { columnName: "city" },
        ],
      },
    ];
  };

  const buildLicenseList = ({
    titleId,
    matches,
    dateTitleId,
    sortDescending,
  }) => {
    title = intl.formatMessage({ id: titleId });
    schoolsWithSelectedLicense.forEach((school) => {
      school.programLicenses
        .filter(
          (license) =>
            license.name === props.selectedLicenseDetail[1] && matches(license),
        )
        .forEach((license) => {
          rows.push({
            id: license.id,
            parentId: null,
            licenseName: license.name,
            customerNumber: school.fortKnoxCustomerNumber,
            nameText: school.name,
            name: props.onSchoolClick ? (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  props.onSchoolClick(school, license);
                }}
              >
                {school.name}
              </a>
            ) : (
              school.name
            ),
            address: school.adress.street,
            postalNumber: school.adress.zipCode,
            city: school.adress.city,
            licenseDate: formatDate(license.validTo, "yyyy-MM-dd"),
            autoRenew: autoRenewText(license),
          });
        });
    });
    rows.sort((a, b) => {
      let compared = a.licenseDate.localeCompare(b.licenseDate);
      return sortDescending ? -compared : compared;
    });
    listColumns = [
      { name: "licenseName", titleId: "ProgramLicense" },
      { name: "customerNumber", titleId: "FortnoxNumber" },
      { name: "name", titleId: "Name", excelField: "nameText" },
      { name: "address", titleId: "Address" },
      { name: "postalNumber", titleId: "ZipCode" },
      { name: "city", titleId: "City" },
      { name: "licenseDate", titleId: dateTitleId },
      { name: "autoRenew", titleId: "AutoRenew" },
    ];
    columns = listColumns.map((column) => ({
      name: column.name,
      title: <FormattedMessage id={column.titleId} />,
    }));
  };

  if (props.selectedLicenseDetail[0] === "LicenseDiff") {
    getDataForLicenseDiff();
  } else if (props.selectedLicenseDetail[0] === "Active") {
    buildLicenseList({
      titleId: "ActiveLicenseTableTitle",
      matches: (license) => !license.hasExpired,
      dateTitleId: "ValidUntil",
    });
  } else if (props.selectedLicenseDetail[0] === "Expired") {
    buildLicenseList({
      titleId: "ExpiredLicenseTableTitle",
      matches: (license) => license.hasExpired,
      dateTitleId: "LicenseExpiredAt",
      sortDescending: true,
    });
  } else if (props.selectedLicenseDetail[0] === "Expiring") {
    buildLicenseList({
      titleId: "ExpiringLicenseTableTitle",
      matches: (license) => license.hasExpireWarning,
      dateTitleId: "LicenseExpiringAt",
    });
  }

  const fnExcelReport = function () {
    let fileName = "";
    var tab_text = "<table>";
    if (props.selectedLicenseDetail[0] === "LicenseDiff") {
      fileName = "LicenserFörÅret" + props.selectedLicenseDetail[1] + ".xls";
      tab_text =
        tab_text +
        "<tr><th align='left'>" +
        intl.formatMessage({ id: "Month" }) +
        "</th><th align='left'>" +
        intl.formatMessage({ id: "ExpiredLicenses" }) +
        "</th><th align='left'>" +
        intl.formatMessage({ id: "AddedLicenses" }) +
        "</th><th align='left'>" +
        intl.formatMessage({ id: "FortnoxNumber" }) +
        "</th><th align='left'>" +
        intl.formatMessage({ id: "Name" }) +
        "</th><th align='left'>" +
        intl.formatMessage({ id: "Address" }) +
        "</th><th align='left'>" +
        intl.formatMessage({ id: "ZipCode" }) +
        "</th><th align='left'>" +
        intl.formatMessage({ id: "City" }) +
        "</th></tr>";
      tab_text = tab_text + dataForYearExcel;
    } else {
      fileName =
        listFileNamePrefixes[props.selectedLicenseDetail[0]] +
        props.selectedLicenseDetail[1] +
        ".xls";
      tab_text +=
        "<tr>" +
        listColumns
          .map(
            (column) =>
              "<th align='left'>" +
              intl.formatMessage({ id: column.titleId }) +
              "</th>",
          )
          .join("") +
        "</tr>";
      rows.forEach((row) => {
        tab_text +=
          "<tr>" +
          listColumns
            .map(
              (column) =>
                "<td align='left'>" +
                row[column.excelField ?? column.name] +
                "</td>",
            )
            .join("") +
          "</tr>";
      });
    }
    tab_text = tab_text + "</table>";
    var data = new Blob(["\ufeff", tab_text], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      encoding: "utf-8",
    });
    saveAs(data, fileName);
  };

  //TODO Set correct title!
  return (
    <div className="container-fluid admin-container">
      <Row className="mb-2">
        <Col>
          <Button color="primary" outline onClick={() => props.closeDetails()}>
            <FontAwesomeIcon icon="xmark" />
          </Button>
          <Button
            className="ms-2"
            color="primary"
            outline
            onClick={fnExcelReport}
          >
            <FormattedMessage id="ExportToXls" />
          </Button>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="h4">
            {title}
            {props.selectedLicenseDetail[1]}
          </p>
        </Col>
      </Row>
      <LicensesDetailsTable
        rows={rows}
        cols={columns}
        columnBands={columnBands}
      />
    </div>
  );
};

export default LicensesDetails;
